import { CR, entityState, jkLib } from "jk-service";
import { StktmServicePkg } from "./stktmPkg.service";
import { Stktm } from "../_entity_stk";


export class StktmService extends StktmServicePkg {
  _whereIn: string = '';
  whereIn(where: string, fieldName: string): string {
    if (this._whereIn === '') {
      return where;
    } else {
      return where + ' AND ' + fieldName + ' ' + this._whereIn;
    }
  }
  constructor() {
    super();
    this.columnDefsVir.push({
      field: 'MONITOR',
      headerName: '價格追蹤',
      headerTooltip: '',
      width: 100,
      cellDataType: 'number',
      editable: false,
      sortable: true,
      filter: 'agNumberColumnFilter',
    });
    /*this.columnLabel = {
      TM001: '單號', TM002: '商品代號', TM003: '名稱', TM004: '結案碼', TM005: '更新時間', TM006: '狀態', TM007: '日期', TM008: '庫存數量', TM009: '最大數量', TM010: '平均成本',
      TM011: '觀盤重點', TM110: '突破通知價',
      TM111: '跌破通知價', TM112: '停損價', TM113: '第一停利價', TM114: '第二停利價', TM115: '支撐1', TM116: '支撐2', TM117: '壓力',TM118:  '智慧單買價',
      nStockidx: '商品自定索引代號',
      sDecimal: '小數位數',
      sTypeNo: '類股別',			//  EX: (證券)類股別 1 水泥 , 2 食品…etc.',
      bstrMarketNo: '市埸代碼',		// 市埸代碼',
      //stockno: '商品代碼',		// 商品代碼EX: 1101 台泥, TX12 台指期12月…etc.',
      bstrStockName: '商品名稱',	// 商品名稱',
      nHigh: '最高價',
      nOpen: '開盤價',
      nLow: '最低價',
      nClose: '成交價',
      nTickQty: '單量',
      nRef: '昨收、參考價',
      nBid: '買價',
      nBc: '買量',
      nAsk: '賣價',
      nAc: '賣量',
      nTBc: '買盤量(即外盤量)',
      nTAc: '賣盤量(即內盤量)',
      nFutureOI: '期貨未平倉 OI',
      nTQty: '總量',
      nYQty: '昨量',
      nUp: '漲停價',
      nDown: '跌停價',
      nSimulate: '試算',	// 揭示 0:一般 1:試算　＊ // [證券逐筆]盤中出現『1:試算』代表行情劇動，觸發價格穩定措施狀態
      nDayTrade: '可否當沖',	// [限證券整股商品]可否當沖 0:一般 1:可先買後賣現股當沖 2:可先買後賣和先賣後買現股當沖
      nTradingDay: '當日'	// 交易日(YYYYMMDD)  備註 :當日非交易日時, 資料為前一交易日
    };
    */

    /*this.sqlSelect = 'SELECT TOP 500 TM001, TM002, TM003, TM004, TM005, TM006, TM007, TM008, TM009, TM010,'+CR+
    ' TM110+TM111+TM112+TM113+TM114+TM115+TM116+TM117+TM118+TM119 AS MONITOR,'+CR+
    'TM011, TM012, TM110,TM111, TM112, TM113, TM114, TM115, TM116, TM117,0 as nStockidx,0 as sDecimal,0 as  sTypeNo,\'\' as bstrMarketNo,\'\' as bstrStockName,' + CR +
    ' 0 as nAc,0 as nAsk,0 as nBc,0 as nBid,0 as nClose,0 as nDecimal,0 as nDown,0 as nFutureOI,0 as nHigh,0 as nLow,0 as nOpen,0 as nRef,0 as nTickQty,0 as nTQty,0 as nTAc,0 as nTBc,0 as nUp,0 as nYQty ' + CR +
    '  FROM STKTM';*/
    this.getStocknosWhere();
  }
override async newRecord(newItem: Stktm): Promise<Stktm> {
    await super.newRecord(newItem);
    newItem.TM001 = Date.now().toString();//await jkLib.geneSerialNo13();
    newItem.TM005 = new Date();
    newItem.TM007 = jkLib.nowDate();
    return newItem;
  }
  // 客製開始====================================================
  override async validateItem(item: Stktm): Promise<boolean> {
    let bool = await super.validateItem(item);
    if (!bool) return false;
    bool = await this.advCheck('TM002', this.item, 'STKMA', 'V03', 'TM003,XQNO', [this.item.TM002], 'E', '商品代號錯誤.');
    // 檢查是否有重複
    let ret = await this.orm.advCheck(item, 'STKTM', 'V02', 'TM001', [item.TM001, item.TM002], 'N');
    if (ret.result) {
      alert('商品代號' + item.TM002 + '重複.');
      return false;
    }
    return bool;
  }
  doClearPrice() {
    if (this.state !== entityState.dsBrowse) {
      this.item.TM110 = 0;
      this.item.TM111 = 0;
      this.item.TM112 = 0;
      this.item.TM113 = 0;
      this.item.TM114 = 0;
      this.item.TM115 = 0;
      this.item.TM116 = 0;
      this.item.TM117 = 0;
    }
  }
  getStocknosWhere() {
    let sql = `SELECT TM002 FROM STKTM WHERE TM004='N' ORDER BY TM002 `;
    this.orm.simpleSql(this.host, sql).subscribe((data: any) => {
      if (data.length > 0) {
        this._whereIn = ' IN (' + data.map((item: any) => `'${item.TM002}'`).join(',') + ')';
      } else {
        this._whereIn = '';
      }
    });
  }

}
